// extracted by mini-css-extract-plugin
export var dataCell = "_nf-2";
export var dataRow = "_nf-0";
export var headerRow = "_nf-1";